import React from "react";
import { Skeleton } from "primereact/skeleton";

const ClientWiseCategorySkeleton = () => {
  return (
    <div className="table-responsive mx-4" style={{ marginBottom: "5%" }}>
      <table className="table table-borderless mb-0 clientsTable">
        <thead>
          <tr
            className="text-muted text-uppercase"
            style={{ fontSize: "12px", borderBottom: "1px solid lightgray" }}
          >
            <th style={{ width: "5%" }}>
              <Skeleton width="30px" />
            </th>
            <th style={{ width: "20%" }}>
              <Skeleton width="100px" />
            </th>
            <th>
              <Skeleton width="100%" />
            </th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 5 }).map(
            (
              _,
              index, // Adjust the length as needed
            ) => (
              <tr key={index}>
                <td>
                  <Skeleton width="30px" />
                </td>
                <td>
                  <Skeleton width="100px" />
                </td>
                <td>
                  <Skeleton width="100%" />
                </td>
              </tr>
            ),
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ClientWiseCategorySkeleton;
